import React, { useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import 'mobx-react-lite/batchingForReactDom';
import { useStores } from '../../../hooks';
import { SimulcastTable } from '../../../elements';
import { schema } from './schema';
import ProxyBidModal from './ProxyBidModal';

const ProxyBidsHome = observer(({ AuctionID, auctionName }) => {
  const {
    ProxyBidStore: {
      isLoading,
      proxyBids: data,
      totalItems,
      loadProxyBids,
      updateProxyBid,
      deleteProxyBid,
    },
  } = useStores();

  const [proxyEditModal, setProxyEditModal] = useState(false);
  const [proxyState, setProxyState] = useState({ test: 'test' });

  const {
    headerSchema,
    tableSettings: {
      getMethods,
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  const proxies = {
    auctionId: AuctionID,
    fn: loadProxyBids,
  };

  const proxyStateObject = {
    fn: async (
      auctionID,
      proxyBidID,
      proxyBid,
      bidderNumber,
      lotNumber,
      memberName,
    ) =>
      await new Promise((resolve, reject) => {
        setProxyState({
          auctionID,
          proxyBidID,
          proxyBid,
          bidderNumber,
          lotNumber,
          memberName,
        });
        setProxyEditModal(true);
        resolve();
      }),
    args: [
      'auctionID',
      'proxyBidID',
      'proxyBid',
      'bidderNumber',
      'lotNumber',
      'memberName',
    ],
  };

  const methods = getMethods(proxies);

  return (
    <>
      {proxyEditModal && (
        <ProxyBidModal
          initialModalOpenState={proxyEditModal}
          onClose={() => {
            setProxyEditModal(false);
          }}
          onDelete={async (data) => {
            const res = await deleteProxyBid(data);
            window.location.reload();
            return res;
          }}
          onUpdate={async (data) => {
            const res = await updateProxyBid(data);
            window.location.reload();
            return res;
          }}
          state={proxyState}
        />
      )}
      <SimulcastTable
        bodySchema={bodySchema}
        debugging={debugging}
        headerSchema={headerSchema}
        initialMediaState={null}
        initialSortDirection={initialSortDirection}
        initialSortColumn={initialSortColumn}
        isLoading={isLoading}
        methods={methods}
        pageSelectTitle={pageSelectTitle}
        searchFields={searchFields}
        rowData={data}
        state={{ auctionName, auctionID: AuctionID, proxyStateObject }}
        totalItems={totalItems}
        exportButton={{
          visible: data.length > 0,
          fileName: `ProxyBidsReport-${auctionName}`,
          sheetName: 'Proxy Bids Report',
          showLocation: ['top'],
        }}
      />
    </>
  );
});

export default ProxyBidsHome;
